import { useTranslation } from 'react-i18next';
import { ChevronRightIcon } from '../../../assets/icons';
import {
  RightCircularArrowButton,
  SeeAllContainer,
  SeeAllInnerWrapper,
  SeeAllText,
  SeeAllWrapperContainer,
} from '../style';

export const SeeAllCard = ({ handleClick }: { handleClick: () => void }) => {
  const { t } = useTranslation();

  return (
    <SeeAllContainer>
      <SeeAllWrapperContainer onClick={handleClick}>
        <SeeAllInnerWrapper>
          <RightCircularArrowButton className="shadow seeAll">
            <ChevronRightIcon fillColor={'#000'} width={26} height={26} />
          </RightCircularArrowButton>
          <SeeAllText>{t('carousel.seeAll')}</SeeAllText>
        </SeeAllInnerWrapper>
      </SeeAllWrapperContainer>
    </SeeAllContainer>
  );
};
